import { FC } from 'react';

export const FitlineFIcon: FC<{
  readonly size: number;
  readonly className?: string;
}> = ({ size, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    className={className}
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M10.4551 13.5595C11.862 11.1504 17.0024 4.70636 17.2738 3.6228C17.3552 3.29806 16.9491 3 16.6244 3C16.0289 3 15.3528 4.05555 15.028 4.48898L12.0787 8.52249C8.45332 13.6942 6.88366 16.6722 5.99147 19.3794C5.61206 20.4897 6.29153 21.1911 7.02169 21.0564C7.94188 20.8937 9.16014 20.3003 11.2106 19.8962C13.2963 19.4848 15.0227 19.3761 16.561 19.5421C16.7497 19.5621 18.1033 19.9215 18.1033 18.8653C18.1033 17.8091 13.053 17.6471 7.7225 19.2447C8.31796 17.2136 9.40019 15.3733 10.4557 13.5589"
      fill="currentColor"
    />
  </svg>
);
